<template>
  <v-dialog
    hide-overlay
    :overlay-opacity="0"
    transition="fade-transition"
    persistent
    ref="dialog"
    :value="!!isOpen"
    absolute
  >
    <div class="card-overlay" @click="onOverlayClick"/>

    <v-card style="width: 560px" class="" v-if="isOpen">
      <!--      <template-->
      <!--        v-if="selectedTheme !== undefined && Object.keys(selectedTheme).length && selectedTheme.screenshot_url"-->
      <!--      >-->
      <!--        <v-img-->
      <!--          height="285px"-->
      <!--          width="100%"-->
      <!--          position="top center"-->
      <!--          :src="selectedTheme.screenshot_url"-->
      <!--        />-->
      <!--        <v-divider />-->
      <!--      </template>-->

      <v-card-title class="pb-0 flex justify-space-between align-center">
        <h4>
          {{ $t("heading.onboarding.transferDomain.title") }}
        </h4>
        <v-btn x-small icon :disabled="loading" @click="closeModal" class="close-model">
          <v-icon>$close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-10 pt-8">
        <div v-if="localErrorMessage" class="mb-6 alert-box alert">
          <span class="font-weight-600 mb-0">{{ localErrorMessage }}</span>
        </div>

        <h6 class="p-2 font-weight-light text-justify">
          <i18next
            :translation="$t('heading.onboarding.transferDomain.subtitle')"
          >
            <template #domain><span class="font-weight-600">{{ domain }}</span></template>
          </i18next>
        </h6>

        <template v-if="canSelectedServiceTransferDomain()">
          <div class="p-2 mt-2 text-justify">
            <p class="mb-4 text--darken1">
              <i18next
                :translation="$t('heading.onboarding.transferDomain.message.possible.title')"
              >
                <template #domain
                  ><span class="font-weight-800">{{ domain }}</span></template
                >
              </i18next>
            </p>

            <p class="mb-3 text--darken1">
              {{ $t("heading.onboarding.transferDomain.message.possible.stepsTitle") }}
            </p>

            <ol class="pl-4">
              <li class="mb-1 text--darken1">
                <i18next
                  :translation="$t('heading.onboarding.transferDomain.message.possible.step1')"
                >
                  <template #domain
                    ><span class="font-weight-800">{{ domain }}</span></template
                  >
                </i18next>
              </li>
              <li class="mb-1 text--darken1">
                <i18next
                  :translation="$t('heading.onboarding.transferDomain.message.possible.step2WithHost')"
                >
                  <template #domain><span class="font-weight-800">{{ domainVerificationRecord.name }}</span></template>
                  <template #recordHost><span class="font-weight-800">@</span></template>
                  <template #recordType
                    ><span class="font-weight-800">{{
                      domainVerificationRecord.type
                    }}</span></template
                  >
                </i18next>
              </li>
              <li class="mb-1 text--darken1">
                {{ $t("heading.onboarding.transferDomain.message.possible.step3") }}
              </li>
              <li class="text--darken1">
                {{ $t("heading.onboarding.transferDomain.message.possible.step4") }}
              </li>
            </ol>
          </div>

          <long-value-box
            v-if="effectiveDomainVerificationRecord && effectiveDomainVerificationRecord.content"
            class="mt-4"
            :value="effectiveDomainVerificationRecord.content"
            :can-expand="false"
          />
        </template>
        <template v-else>
          <p class="p-3 mt-2">
            {{ $t('heading.onboarding.transferDomain.message.impossible') }}
          </p>
        </template>
      </v-card-text>
      <v-card-actions class="d-flex flex-column pb-6 px-10 pt-2 mt-4">
        <v-btn
          v-if="isDomainTransferEnabled"
          x-large
          elevation="0"
          color="primary"
          block
          :disabled="loading || submitting"
          @click="onTransferClick"
          :loading="loading || submitting"
        >
          <template v-slot:loader>
            <v-progress-circular
              v-if="loadingText !== ''"
              indeterminate
              size="20"
              width="2"
              class="mr-2"
            ></v-progress-circular>
            <span>{{ $t(loadingText) }}</span>
          </template>
          <template v-if="this.hasSelectedServiceInstantVerificationEnabled()">
            <span>{{ $t("button.continue") }}</span>
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
          <template v-else-if="hasSelectedServiceAskForSiteName()">
            <span>{{ $t("button.website.set") }}</span>
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
          <template v-else>
            <span>{{ $t("button.transferNow") }}</span>
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
        </v-btn>
        <v-btn
          v-if="services.length > 1"
          :disabled="loading"
          @click="onChangeServiceClick"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
        >
          <span class="p-1 font-weight-light gray--text text--darken-1">
            {{ $t("button.service.change") }}
          </span>
        </v-btn>
        <v-btn
          v-else
          :disabled="loading"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
          @click="closeModal"
        >
          <span class="p-1 font-weight-light gray--text text--darken-1">
            {{ $t("button.back") }}
          </span>
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import LongValueBox from "@/components/common/LongValueBox.vue";
import Api from "@/apis/Api";
import OnboardingSelectedServiceMixin from "../../mixins/OnboardingSelectedServiceMixin";

export default {
  name: "OnboardingDomainTransferModal",
  components: {LongValueBox},
  mixins: [OnboardingSelectedServiceMixin],
  props: {
    isOpen: [Boolean, String],
    loading: Boolean,
    loadingText: {
      type: String,
      default: "",
    },
    selectedTheme: Object,
    services: Array,
    selectedService: {
      type: Object,
      default: () => {
      },
    },
    domain: String,
    domainVerificationRecord: Object,
  },
  data() {
    return {
      isDomainVerified: false,
      submitting: false,
      localErrorMessage: "",
      localDomainVerificationRecord: null,
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    async onTransferClick() {
      if (this.loading || this.submitting) return;
      this.localErrorMessage = "";
      this.submitting = true;
      try {
        if (this.isSelectedServiceServerAllowTransferDomain()) {
          const response = await Api.get(
            `/services/${this.selectedService.id}/domains/verify?domain=${this.domain}`
          );
          const result = response.data;

          if (result?.verification_required) {
            this.localDomainVerificationRecord = result.verification_record;
            this.$emit("verification-record-updated", result.verification_record);
            this.localErrorMessage = this.$t("heading.onboarding.transferDomain.message.verificationRequired");
            this.submitting = false;
            return;
          }
        }

        this.submitting = false;
        this.$emit('transfer-domain');
      } catch (error) {
        this.localErrorMessage = Api.getErrorMessage(error);
        this.submitting = false;
      }
    },
    closeModal() {
      if (!this.loading) {
        this.$emit('remove-modal');
      }
    },
    onOverlayClick() {
      if (!this.loading && this.$refs.dialog) {
        this.$refs.dialog.animateClick();
      }
    },
    onChangeServiceClick() {
      if (!this.loading) {
        this.$emit('change-service-button-clicked');
      }
    },
    handleBeforeUnload(e) {
      if (!this.loading) {
        return;
      }
      const message = 'Installation is in progress. Leaving the page may cause the process to fail.';
      (e || window.event).returnValue = message;
      return message;
    },
  },
  computed: {
    isDomainTransferEnabled() {
      return this.selectedService?.onboarding.domain_transfer_enabled;
    },
    effectiveDomainVerificationRecord() {
      return this.localDomainVerificationRecord || this.domainVerificationRecord;
    },
  },
  watch: {
    isOpen: function (value) {
      value
        ? this.$store.dispatch("lockBodyScroll")
        : this.$store.dispatch("unlockBodyScroll");
      if (value) {
        this.localErrorMessage = "";
        this.localDomainVerificationRecord = this.domainVerificationRecord || null;
      }
    },
  },
}
</script>


<style lang="scss" scoped>
.main-warning-message {
  background: var(--v-primary-lighten4);
  border-radius: 6px;

  h5 {
    margin: 0;
    font-size: 1.1em;
    color: var(--v-primary-base);

    strong {
      color: var(--v-primary-darken1) !important;
    }
  }
}

.v-dialog__content::v-deep {
  .v-dialog {
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.close-model {
  position: absolute;
  top: -40px;
  right: -8px;
}

.v-card::v-deep {
  .v-card__text {
    -webkit-line-clamp: unset !important;
  }

  @media (max-width: 480px) {
    .v-card__text,
    .v-card__actions {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
}

.alert-box {
  width: 100%!important;
  min-width: 100%!important;
  padding: 16px;
  text-align: center;
  border-radius: 8px;

  &.ok {
    background: var(--v-success-lighten5);
    color: var(--v-success-base);
  }

  &.alert {
    background: var(--v-error-lighten5);
    color: var(--v-error-base);
  }
}

</style>